__turbopack_context__.v({
  "adornment": "text-field-module-scss-module__LEqIgq__adornment",
  "control": "text-field-module-scss-module__LEqIgq__control",
  "error": "text-field-module-scss-module__LEqIgq__error",
  "head": "text-field-module-scss-module__LEqIgq__head",
  "hint": "text-field-module-scss-module__LEqIgq__hint",
  "input": "text-field-module-scss-module__LEqIgq__input",
  "label": "text-field-module-scss-module__LEqIgq__label",
  "root": "text-field-module-scss-module__LEqIgq__root",
  "suffix": "text-field-module-scss-module__LEqIgq__suffix",
});
